export default __webpack_public_path__ + "static/media/ubicacion.7831a12f.svg";